import type { PersonCriteria } from '../../../gql/typings';
import type { BuiltCriteria } from '../../util/criteriaBuilderSelector';

// Preserve the search's complete filter tree; pagination belongs only to the table.
export const personSelectionCriteria = (
  criteria: BuiltCriteria['criteria'] | PersonCriteria
): PersonCriteria => {
  const result = { ...criteria, aPureBaseIds: criteria.aPureBaseIds?.map(Number) } as PersonCriteria;
  delete result.fetchSize;
  delete result.ordering;
  return result;
};
